var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fc-snackbar__wrapper" }, [
    _c("div", { staticClass: "fc-snackbar" }, [
      _c("h1", { staticClass: "fc-snackbar__title" }, [
        _vm._v(_vm._s(_vm.title)),
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "fc-snackbar__content",
        domProps: { innerHTML: _vm._s(_vm.subTitle) },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "fc-snackbar__button" }, [
        _c(
          "button",
          {
            staticClass: "btn-text",
            attrs: { type: "button" },
            on: { click: _vm.close },
          },
          [_vm._v(_vm._s(_vm.closeButtonText))]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn-confirm",
            attrs: { type: "button" },
            on: { click: _vm.complete },
          },
          [_vm._v(_vm._s(_vm.buttonText))]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }